var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPantry = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 3h20v6h-7v5l-3-1-3 1V9H2V3Zm18 4V5H4v2h16Zm-9 2v2.5l1-.5 1 .5V9h-2Z",
  fill: "#191C29",
  fillOpacity: 0.54
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M5 10v9h14v-9h2v11H3V10h2Z",
  fill: "#191C29",
  fillOpacity: 0.54
})));
export default SvgPantry;